module.exports = __webpack_public_path__ + "img/img13.dd2983cc.svg";